export const apiFetch = (url: string, options: any = {}): Promise<Response> => {

    const headers = {
        ...options.headers,
    };

    return fetch(`${process.env.NEXT_PUBLIC_API_URL}/${url}`, {
        ...options,
        headers,
    });
};
